import { SocialTab, SocialTabType } from '@/models/Social/Profile/social-tab';
import { SocialPosts } from "@/models/Social/social-posts";
import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";


export class SocialTabBlocks extends SocialTab{
    protected _posts: SocialPosts;
    protected _isMobile: boolean = true;

    public constructor(name?: string, params?: object, contentUrl?: string, isMobile: boolean = true) {
        super(name, params, contentUrl);
        this._posts = new SocialPosts((contentUrl??''),(params??{}));
    }

    public hasContent(): boolean{
        return this._posts.structs.length > 0;
    }

    public hasNextPage(): boolean{
        return this._posts._nextpage != null;
    }

    public nextPage(): void{
        this._posts.nextPage();
    }

    public getData():Array<TemplateStruct>{
        return this._posts.structs;
    }

    public get type(): SocialTabType{
        return SocialTabType.blocks;
    }
}